import { createFileRoute } from "@tanstack/react-router";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";
import { PageHeader } from "@/components/app/shell/page-header";
import { useFacility } from "@/lib/facility/facility";
import { guardRoute } from "@/lib/policy/route-guard";
import { BuildingInsights } from "./-components/building-insights";
import { VisitorNav } from "./-components/visitor-nav";

export const Route = createFileRoute("/_authenticated/_visitors/visitors/insights")({
  beforeLoad: ({ context }) => guardRoute(context.me, "visitors"),
  component: VisitorInsightsPage,
});

/** What the front door did over a stretch of days at one building. */
function VisitorInsightsPage() {
  const { facilityId } = useFacility();
  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Visitor insights"
        meta="Who came and when, how fast they got in, and how Grace and the kiosks held up."
      />
      <VisitorNav />
      {facilityId === "all" ? (
        <OneBuildingCard prompt="Insights cover one building at a time. Choose the building." />
      ) : (
        <BuildingInsights key={facilityId} facilityId={facilityId} />
      )}
    </div>
  );
}
